import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "email",
    "password",
    "error",
    "info",
    "submitBtn",
    "btnText",
    "btnLoading",
  ];
  static values = {
    mode: String,
    supabaseUrl: String,
    supabaseKey: String,
  };

  connect() {
    this.client = window.supabase.createClient(
      this.supabaseUrlValue,
      this.supabaseKeyValue,
    );
  }

  async submit(event) {
    event.preventDefault();
    this.hideError();
    this.setLoading(true);

    const email = this.emailTarget.value;
    const password = this.passwordTarget.value;

    try {
      const result = this.isSignup
        ? await this.client.auth.signUp({
            email,
            password,
            options: {
              emailRedirectTo: `${window.location.origin}/auth/callback`,
            },
          })
        : await this.client.auth.signInWithPassword({ email, password });

      if (result.error) throw result.error;

      if (this.isSignup && !result.data.session) {
        this.showInfo("Revisa tu email para confirmar tu cuenta");
        this.setLoading(false);
        return;
      }

      const accessToken = result.data.session.access_token;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const response = await fetch("/login", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `access_token=${encodeURIComponent(accessToken)}&timezone=${encodeURIComponent(timezone)}`,
      });

      window.location.href = response.redirected ? response.url : "/";
    } catch (error) {
      console.error("Auth error:", error);
      this.showError("Error de autenticación");
      this.setLoading(false);
    }
  }

  get isSignup() {
    return this.modeValue === "signup";
  }

  showError(message) {
    this.errorTarget.textContent = message;
    this.errorTarget.classList.remove("hidden");
  }

  hideError() {
    this.errorTarget.classList.add("hidden");
  }

  showInfo(message) {
    this.infoTarget.textContent = message;
    this.infoTarget.classList.remove("hidden");
  }

  setLoading(loading) {
    this.submitBtnTarget.disabled = loading;
    this.btnTextTarget.classList.toggle("hidden", loading);
    this.btnLoadingTarget.classList.toggle("hidden", !loading);
  }
}
